import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@ts-digital/vrc";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getDocumentsWithSearch } from "../../../store/actions/documentsWithSearch";
import WidgetsPrecogCard from "./card";

const WidgetDocuments = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();  
  const documentsWithSearch = useSelector(state => state.documentsWithSearch);
  
  /** Devo recuperare il link per il filtro della inbox */
  const filterDocuments = documentsWithSearch?.filters?.list?.find(el => el.title==="Macro Categoria");
  const inBoxFilter = filterDocuments?.links?.find(el => el.label === "Inbox");

  useEffect(() => {    
    dispatch(getDocumentsWithSearch(
      null,
      "",      
      false,
      {
        "macrocategory": "Inbox"
      }
    ));
  }, []);
  
  return (
    <WidgetsPrecogCard isEmpty={false}>
      <div className="title">
        <FormattedMessage id="preCog.widget.documents"/>
      </div>
      <div>
        <div className="subtitle">
          Documenti in inbox
        </div>
        <div className="flexLink">
          <div>{inBoxFilter?.count} documenti</div>
          <div data-testid="goToDocumentsLink" onClick={e =>  navigate("/documenti", {state: {categoryFilter: {label: inBoxFilter?.label, link: inBoxFilter?._links.self.href}}})}>
            <FontAwesomeIcon
              icon={["fas", "arrow-right"]}
              style={{ color: "#0090d1", cursor: "pointer" }}
            />
          </div>
        </div>
        <div className="bottomButton">
          <Button colorScheme={"ghost"} kind={"secondary"} 
            onClick={() => navigate("/carica-documenti", {state: {isAccountable: true}})}>
            <div style={{display: "flex", alignItems: "center"}}>
              <FontAwesomeIcon icon={["fal", "plus-circle"]} style={{
                color: "#0090d1",
                fontSize: "16px",
                cursor: "pointer",
                marginRight: "8px"
              }}  />
              <FormattedMessage id="preCog.widget.btnNew" />
            </div>
          </Button>
        </div>
      </div>
    </WidgetsPrecogCard>
  );
};

export default WidgetDocuments;